/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_Generate_HintInputs */



/**
* | output |
* | --- |
* | "Click Generate to preview subtitles" |
*
* @param {Video_Export_Preview_Generate_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_generate_hint = /** @type {((inputs?: Video_Export_Preview_Generate_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_Generate_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cliquez sur Generer pour previsualiser les sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Klicken Sie auf „Generieren“, um eine Vorschau der Untertitel anzuzeigen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fare clic su Genera per visualizzare l'anteprima dei sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нажмите «Создать», чтобы просмотреть субтитры.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Haga clic en Generar para obtener una vista previa de los subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("点击“生成”预览字幕。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕をプレビューするには「生成」をクリックします")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षकों का पूर्वावलोकन करने के लिए जनरेट पर क्लिक करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Clique em Gerar para pré-visualizar as legendas.")
	return /** @type {LocalizedString} */ ("Click Generate to preview subtitles")
});